import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";

import { $templates } from "../../internal/templates";

/**
 * Hook to access available document templates.
 *
 * @returns Object containing:
 * - `templates`: Array of available template repositories
 * - `isLoading`: Whether templates are currently being fetched
 * - `error`: Error object if fetching failed, null otherwise
 */
export const useTemplates = () => {
	const templatesLoadable = useAtomValue(loadable($templates));

	const templates = templatesLoadable.state === "hasData" ? templatesLoadable.data : [];
	const isLoading = templatesLoadable.state === "loading";
	const error = templatesLoadable.state === "hasError" ? templatesLoadable.error : null;

	return { templates, isLoading, error };
};
